import { Link } from 'react-router-dom';
import { Scales as Scale, ArrowLeft, EnvelopeSimple } from '@phosphor-icons/react';

/**
 * Join-a-chambers entry (/join-workspace).
 *
 * Joining is by INVITATION: a barrister, clerk or chambers admin invites you, and you receive an
 * email with a secure link that opens the accept-invitation flow (/accept-team-invite/:token).
 * There is no self-serve "enter a code" path by design — so this page tells an invited user where to
 * look rather than dead-ending. (The "Start a practice" entry now goes straight to /onboarding.)
 */
export default function OnboardingComingSoonPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6">
      <div className="w-full max-w-md text-center">
        <div className="mb-6 flex justify-center">
          <div className="flex h-11 w-11 items-center justify-center rounded-md bg-brand-600 text-white">
            <Scale className="h-5 w-5" weight="duotone" />
          </div>
        </div>
        <h1 className="mb-2 text-xl font-semibold tracking-tight text-foreground">Join your chambers</h1>
        <p className="mb-6 text-sm text-muted-foreground">
          Chambers join by invitation. Open the email invitation sent by your chambers, clerk or
          barrister — it contains a secure link that sets up your account. If you can’t find it, ask
          them to resend the invitation.
        </p>
        <div className="mb-6 flex items-center justify-center gap-2 rounded-md border border-border bg-muted/40 px-4 py-3 text-sm text-muted-foreground">
          <EnvelopeSimple className="h-4 w-4 shrink-0" />
          <span>Check your inbox for an invitation from Jurivoxa</span>
        </div>
        <Link
          to="/login"
          className="inline-flex h-10 items-center justify-center gap-2 rounded-md border border-border bg-card px-5 text-sm font-medium text-foreground transition hover:bg-muted/40"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to sign in
        </Link>
      </div>
    </div>
  );
}
